// extracted by mini-css-extract-plugin
module.exports = {"header":"FormPanelHeader_header__1GPKP","filled":"FormPanelHeader_filled__4LvLn","label":"FormPanelHeader_label__2maTf","description":"FormPanelHeader_description__2McQ0"};